import React, { Component } from 'react';
import { Route, Redirect } from 'react-router';
import { AppBody } from './components/AppBody';
import { Home } from './components/Home';
import { FetchData } from './components/FetchData';
import { Counter } from './components/Counter';
import ApiAuthorizationRoutes from './components/api-authorization/ApiAuthorizationRoutes';
import { ApplicationPaths } from './components/api-authorization/ApiAuthorizationConstants';
import { Roles } from './components/admin/Roles';
import { CreateRole } from './components/admin/CreateRole';
import { AccessDenied } from './components/util/AccessDenied';
import './custom.css'
import { Users } from './components/admin/Users';
import { Clients } from './components/admin/Clients';
import { RoleDetails } from './components/admin/RoleDetails';
import { UserDetails } from './components/admin/UserDetails';
import { CreateClient } from './components/admin/CreateClient';
import { ClientDetails } from './components/admin/ClientDetails';
import { Accounts } from './components/account/Accounts';
import { AccountDetails } from './components/account/AccountDetails';
import { AccountInvoices } from './components/account/AccountInvoices';
import { ManageAssets } from './components/M - Manage Assets/ManageAssets';
import { NewPackingList } from './components/I - Instruments/NewPackingList';
import { ExistingPackingList } from './components/I - Instruments/existingPackingList';
import { CustomerService } from './components/C - Customer Service/customerService';
import { CalsNCerts } from './components/C - Cals n Certs/CalsNCerts';
import { Admin } from './components/admin/Admin';
import { ScheduleOnSite } from './components/schedule/ScheduleOnSite';
import { InquireOrder } from './components/inquire/InquireOrder';
import { CompanyAssets } from './components/M - Manage Assets/CompanyAssets';
import { Login } from './components/auth/Login';
import Session from './components/auth/Session';

export default class App extends Component {
    static displayName = App.name;

    render() {
        return (
            <AppBody>
                <Route path='/counter' component={Counter} />
                <Route exact path='/' component={Home} />
                <Route path='/fetch-data' component={FetchData} />
                <Route exact path='/admin' component={Admin} />
                <Route exact path='/admin/roles' component={Roles} />
                <Route exact path='/admin/roles/create' component={CreateRole} />
                <Route exact path='/admin/roles/details' component={RoleDetails} />
                <Route exact path='/admin/users' component={Users} />
                <Route exact path='/admin/users/details' component={UserDetails} />
                <Route exact path='/admin/clients' component={Clients} />
                <Route exact path='/admin/clients/create' component={CreateClient} />
                <Route exact path='/admin/clients/details' component={ClientDetails} />
                <Route exact path='/accounts' component={Accounts} />
                <Route exact path='/accounts/details' component={AccountDetails} />
                <Route exact path='/accounts/invoices' component={AccountInvoices} />
                <Route exact path='/instrument/NewPackingList' component={NewPackingList} />
                <Route exact path='/instrument/ExistingPackingList' component={ExistingPackingList} />
                <Route exact path='/manageAssets/ManageAssets' component={ManageAssets} />
                <Route exact path='/manageAssets/CompanyAssets' component={CompanyAssets} />
                <Route exact path='/customerService/CustomerService' component={CustomerService} />
                <Route exact path='/calsNCerts/CalsNCerts' component={CalsNCerts} />
                <Route exact path='/schedule/onsite' component={ScheduleOnSite} />
                <Route exact path='/inquire/order' component={InquireOrder} />
                <Route exact path='/login' component={Login} />
                <Route exact path='/logout' render={() => {
                    Session.removeUserSession();
                    window.location.href = '/login';
                    return <></>;
                }} />
                <Route exact path='/forgot' render={() => {
                    window.location.href = '/Identity/Account/ForgotPassword';
                    return <></>;
                }} />
                <Route exact path='/accessdenied' component={AccessDenied} />
                {/*<Route path={ApplicationPaths.ApiAuthorizationPrefix} component={ApiAuthorizationRoutes} />*/}
            </AppBody>
        );
    }
}
